<!-- Console action feedback 0.1.155; 2026-10-28 18:11:13 CST; parent 44dbda7a05c960e3c79c6c322d676ac5e4982b20. -->
<!-- HotX Console 0.1.109 BSC 游客态。实际修改时间：2026-09-16 13:54:40 CST；精确父基线：cf5594169b784b215a2924abbfc0042baef03cbf。 -->
<template>
  <main class="bsc-page">
    <section class="bsc-hero">
      <div>
        <span class="network-chip">BNB SMART CHAIN</span>
        <h1>BSC 充值</h1>
        <p>仅支持 USDT-BEP20。创建 15 分钟付款订单后，系统才会显示您的专属地址并启动链上检测。</p>
      </div>
      <!-- 2026-09-03 CST：返回正式 TRON 独立页；旧 /recharge 仅用于兼容，不再作为页面入口。 -->
      <RouterLink class="tron-link" to="/trx-recharge">前往 TRON 充值</RouterLink>
    </section>

    <el-alert v-if="pageError" :title="pageError" type="error" show-icon closable @close="pageError = ''" />

    <section class="workspace">
      <article class="create-panel">
        <header><h2>选择充值币种</h2><span>无需预填金额</span></header>
        <div class="asset-switch" role="radiogroup" aria-label="BSC 充值币种">
          <button v-for="asset in usdtAssets" :key="asset.assetCode" type="button"
            :class="{ selected: selectedAsset === asset.assetCode }" :disabled="!asset.enabled || Boolean(activeOrder)"
            @click="selectedAsset = asset.assetCode">
            <strong>{{ asset.displayName }}</strong><small>{{ asset.network }}</small>
          </button>
        </div>

        <div class="order-contract">
          <div><b>付款有效期</b><span>15 分钟</span></div>
          <div><b>专线检测</b><span>仅 USDT-BEP20</span></div>
          <div><b>积分结算</b><span>1 积分 = 1 美元</span></div>
        </div>

        <button class="create-button" type="button" :disabled="creating || Boolean(activeOrder) || !config?.rechargeEnabled" @click="createOrder">
          <span v-if="creating" class="spinner" aria-hidden="true" />
          {{ guestMode ? '登录后创建 BSC 付款订单' : activeOrder ? '当前订单进行中' : config?.rechargeEnabled ? '创建 BSC 付款订单' : '充值通道配置中' }}
        </button>
        <p class="privacy-note">为减少误转和空扫，未创建订单时不会展示收款地址，也不会调用 Ankr 扫描。</p>
      </article>

      <article class="payment-panel" :class="{ active: activeOrder }">
        <template v-if="activeOrder">
          <header class="payment-header">
            <div class="scan-status" :class="{ credited: Boolean(activeOrder.creditedCount) }">
              <span><i class="status-dot" />{{ scanStatusTitle }}</span><small>{{ scanStatusDetail }}</small>
            </div>
            <div class="countdown" :class="{ urgent: countdownUrgent }"><small>付款剩余</small><strong>{{ countdown }}</strong></div>
          </header>
          <div v-if="currentDeposit" class="deposit-progress" :class="{ credited: currentDeposit.state === 'CREDITED' }">
            <div><small>链上到账</small><strong>{{ currentDeposit.decimalAmount }} {{ currentDeposit.assetCode === 'USDT_BEP20' ? 'USDT' : 'BNB' }}</strong></div>
            <div><small>确认进度</small><strong>{{ currentDeposit.confirmations }} / {{ currentDeposit.requiredConfirmations }}</strong></div>
            <div><small>积分状态</small><strong>{{ currentDeposit.state === 'CREDITED' ? `+${currentDeposit.creditedPoints || '0.000'} 已到账` : '确认后自动入账' }}</strong></div>
          </div>
          <div class="payment-grid">
            <div class="qr-zone">
              <QrcodeVue v-if="activeOrder.paymentQrContent" :value="activeOrder.paymentQrContent" :size="230" level="M" />
              <b>USDT-BEP20 地址码</b>
              <small>请确认钱包网络为 BNB Smart Chain（BEP20）</small>
            </div>
            <div class="address-zone">
              <span>您的本单专属充值地址</span>
              <div class="address-row"><code>{{ activeOrder.depositAddress }}</code><button type="button" :disabled="copyingAddress" @click="copyAddress">{{ copyingAddress ? '复制中…' : '复制' }}</button></div>
              <div class="asset-notice">
                <strong>本单仅自动识别 USDT-BEP20</strong>
                <p>请勿直接转入 BNB 或其他代币。误充 BNB 可在下方通过交易哈希自助认领，或联系我们处理。</p>
                <div class="claim-actions"><button type="button" @click="recordTab = 'query'">前往自助认领</button><a :href="telegramUrl" target="_blank" rel="noopener noreferrer">联系我们</a></div>
              </div>
              <ol>
                <li>钱包网络必须选择 BNB Smart Chain（BEP20）</li>
                <li>付款后等待 15 个区块确认；大额充值等待 30 个确认</li>
                <li>链上确认后自动换算积分，到账精确到三位小数</li>
              </ol>
            </div>
          </div>
          <footer class="payment-footer">
            <span>订单号 {{ activeOrder.orderId }}</span>
            <button type="button" :disabled="cancelling" @click="cancelOrder">{{ cancelling ? '正在关闭…' : '取消订单' }}</button>
          </footer>
        </template>
        <div v-else class="empty-order">
          <div class="chain-orbit"><span>BSC</span></div>
          <h2>{{ guestMode ? '登录后创建充值订单' : '收款地址已隐藏' }}</h2>
          <p>{{ guestMode ? '当前未登录，登录后可创建订单并查看专属地址、二维码和到账进度。' : '选择币种并创建订单后，这里会显示专属地址、二维码和实时确认进度。' }}</p>
        </div>
      </article>
    </section>

    <section class="records-panel">
      <el-tabs v-model="recordTab">
        <el-tab-pane label="链上入账" name="deposits">
          <el-table :data="deposits" :empty-text="guestMode ? '登录后查看 BSC 链上入账' : '暂无 BSC 链上入账'">
            <el-table-column prop="assetCode" label="币种" width="150" />
            <el-table-column prop="decimalAmount" label="到账数量" min-width="150" />
            <el-table-column label="确认进度" width="150"><template #default="scope">{{ scope.row.confirmations }} / {{ scope.row.requiredConfirmations }}</template></el-table-column>
            <el-table-column prop="creditedPoints" label="到账积分" width="130" />
            <el-table-column prop="state" label="状态" width="170" />
            <el-table-column prop="txHash" label="交易哈希" min-width="250" show-overflow-tooltip />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="历史订单" name="orders">
          <el-table :data="orders" :empty-text="guestMode ? '登录后查看 BSC 充值订单' : '暂无 BSC 充值订单'">
            <el-table-column prop="orderId" label="订单号" min-width="230" />
            <el-table-column prop="selectedAsset" label="选择币种" width="150" />
            <el-table-column prop="status" label="状态" width="190" />
            <el-table-column prop="detectedCount" label="检测笔数" width="100" />
            <el-table-column prop="createdAt" label="创建时间" min-width="180" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="交易哈希查询" name="query">
          <div class="query-row"><el-input v-model="txHash" placeholder="输入 0x 开头的 BSC 交易哈希" /><el-button :loading="querying" @click="selfQuery">自动查询</el-button><a :href="telegramUrl" target="_blank" rel="noopener noreferrer">联系我们</a></div>
        </el-tab-pane>
      </el-tabs>
    </section>
  </main>
</template>

<script setup lang="ts">
import { writeClipboardText } from '../utils/clipboard';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRoute } from 'vue-router';
import QrcodeVue from 'qrcode.vue';
import { bscErrorMessage, bscRechargeApi, type BscAssetCode, type BscDeposit, type BscRechargeConfig, type BscRechargeOrder } from '../api/bscRechargeApi';
import { completeRechargeReturn } from '../features/domain-plan/rechargeReturn';
import { hasConsoleSession } from '../api/client';

const route = useRoute();
const telegramUrl = import.meta.env.VITE_SUPPORT_TELEGRAM_URL || 'https://t.me/hotxcdn';
const fallbackAssets = [
  { assetCode: 'USDT_BEP20' as BscAssetCode, displayName: 'USDT-BEP20', enabled: false, network: 'BNB Smart Chain' }
];
const config = ref<BscRechargeConfig | null>(null);
const activeOrder = ref<BscRechargeOrder | null>(null);
const selectedAsset = ref<BscAssetCode>('USDT_BEP20');
const deposits = ref<BscDeposit[]>([]);
const orders = ref<BscRechargeOrder[]>([]);
const recordTab = ref('deposits');
const pageError = ref('');
const guestMode = computed(() => !hasConsoleSession());
const creating = ref(false);
const cancelling = ref(false);
const querying = ref(false);
const txHash = ref('');
const now = ref(Date.now());
let timer: number | undefined;
let refreshingActive = false;
let rechargeReturnHandled = false;

function notifyRechargeReturn() {
  if (rechargeReturnHandled) return;
  rechargeReturnHandled = true;
  // V1.0 / 2026-09-09 CST / parent 15a7174ab: keep the source form alive in its
  // original tab and only send the confirmed-credit fact across the isolated window.
  void completeRechargeReturn({
    network: 'BSC',
    query: route.query,
    showReturnPrompt: message => ElMessageBox.alert(message, '充值成功', {
      confirmButtonText: '返回原窗口',
      showClose: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      type: 'success'
    }),
    closeRechargeTab: () => window.close()
  });
}

const countdown = computed(() => {
  if (!activeOrder.value) return '00:00';
  // 2026-09-03 CST：容忍浏览器与服务器数秒时钟偏差，但页面绝不展示超过约定的 15 分钟。
  const seconds = Math.min(15 * 60, Math.max(0, Math.floor((new Date(activeOrder.value.expiresAt).getTime() - now.value) / 1000)));
  return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
});
const countdownUrgent = computed(() => Boolean(activeOrder.value) && new Date(activeOrder.value!.expiresAt).getTime() - now.value <= 180_000);
const currentDeposit = computed(() => deposits.value.find(item => item.orderId === activeOrder.value?.orderId));
// 2026-09-03 CST：常规入口只展示 USDT；BNB 误充通过交易哈希按需查询，不参与订单持续扫描。
const usdtAssets = computed(() => (config.value?.assets || fallbackAssets).filter(asset => asset.assetCode === 'USDT_BEP20'));
const scanStatusTitle = computed(() => activeOrder.value?.creditedCount ? '积分已到账' : activeOrder.value?.detectedCount ? '已检测到链上转账' : '链上实时检测中');
const scanStatusDetail = computed(() => activeOrder.value?.creditedCount ? '到账结果已同步，无需刷新页面' : activeOrder.value?.detectedCount ? '正在确认并自动换算积分' : '正在扫描最近区块，通常数秒内更新');

async function loadBase() {
  const [nextConfig, active, depositPage, orderPage] = await Promise.all([
    bscRechargeApi.config(), bscRechargeApi.activeOrder(), bscRechargeApi.deposits(), bscRechargeApi.orders()
  ]);
  config.value = nextConfig; activeOrder.value = active; deposits.value = depositPage.items || []; orders.value = orderPage.items || [];
  if (active?.selectedAsset) selectedAsset.value = active.selectedAsset;
}

async function refreshActive() {
  if (!activeOrder.value || refreshingActive) return;
  refreshingActive = true;
  try {
    const previous = activeOrder.value;
    const next = await bscRechargeApi.activeOrder();
    activeOrder.value = next;
    if (next && (next.detectedCount > 0 || next.creditedCount > 0)) {
      const depositPage = await bscRechargeApi.deposits();
      deposits.value = depositPage.items || [];
      if (next.creditedCount > previous.creditedCount) {
        ElMessage.success('充值积分已到账');
        window.dispatchEvent(new CustomEvent('hotx:points-updated'));
        notifyRechargeReturn();
      }
    }
    if (!next) {
      const [depositPage, orderPage] = await Promise.all([bscRechargeApi.deposits(), bscRechargeApi.orders()]);
      deposits.value = depositPage.items || []; orders.value = orderPage.items || [];
      ElMessage.success('充值已识别，最新积分和链上状态已更新');
      window.dispatchEvent(new CustomEvent('hotx:points-updated'));
      if (deposits.value.some(item => item.orderId === previous.orderId && item.state === 'CREDITED')) {
        notifyRechargeReturn();
      }
    }
  } finally {
    refreshingActive = false;
  }
}

async function createOrder() {
  if (creating.value || activeOrder.value || !config.value?.rechargeEnabled) return;
  creating.value = true; pageError.value = '';
  try {
    activeOrder.value = await bscRechargeApi.createOrder(selectedAsset.value, crypto.randomUUID());
    ElMessage.success('BSC 付款订单已创建，链上检测已开启');
  } catch (error) { pageError.value = bscErrorMessage(error, '订单创建失败，请稍后再试。'); }
  finally { creating.value = false; }
}

async function cancelOrder() {
  if (!activeOrder.value || cancelling.value) return;
  cancelling.value = true;
  try {
    await bscRechargeApi.cancel(activeOrder.value.orderId);
    activeOrder.value = null;
    ElMessage.success('订单已关闭，系统将在后台完成最后一次检测');
    orders.value = (await bscRechargeApi.orders()).items || [];
  } catch (error) { pageError.value = bscErrorMessage(error, '订单关闭失败，请稍后再试。'); }
  finally { cancelling.value = false; }
}

const copyingAddress = ref(false);
async function copyAddress() {
  if (copyingAddress.value) return;
  if (!activeOrder.value?.depositAddress) { ElMessage.warning('当前没有可复制的收款地址。'); return; }
  copyingAddress.value = true;
  try { await writeClipboardText(activeOrder.value.depositAddress); ElMessage.success('BSC 收款地址已复制'); }
  catch { ElMessage.error('复制失败，请重试或手动选择收款地址复制。'); }
  finally { copyingAddress.value = false; }
}

async function selfQuery() {
  if (!txHash.value.trim() || querying.value) return;
  querying.value = true;
  try { await bscRechargeApi.selfQuery(txHash.value.trim()); ElMessage.success('交易已找到，系统正在确认并处理入账'); deposits.value = (await bscRechargeApi.deposits()).items || []; }
  catch (error) { pageError.value = bscErrorMessage(error, '交易查询失败，请稍后再试。'); }
  finally { querying.value = false; }
}

onMounted(async () => {
  if (hasConsoleSession()) {
    try { await loadBase(); } catch (error) { pageError.value = bscErrorMessage(error, 'BSC 充值信息加载失败，请稍后再试。'); }
  }
  // 2026-09-03 CST：订单期间 2 秒刷新一次页面状态；该请求只读本地数据库，不会额外调用 Ankr。
  timer = window.setInterval(() => { now.value = Date.now(); if (activeOrder.value) refreshActive().catch(() => undefined); }, 2000);
});
onBeforeUnmount(() => { if (timer) window.clearInterval(timer); });
</script>

<style scoped>
.bsc-page{--ink:#102944;--green:#087f67;--mint:#e7f5ef;--gold:#d8a62a;display:grid;gap:20px;padding:28px;min-height:100%;background:radial-gradient(circle at 82% 8%,#fff3ce 0,transparent 27%),linear-gradient(135deg,#edf7f1,#fffdf5 68%);color:var(--ink)}
.bsc-hero{display:flex;align-items:center;justify-content:space-between;padding:28px 32px;border-radius:16px;background:linear-gradient(110deg,#0c294e,#087b73);color:white;box-shadow:0 18px 36px rgba(16,41,68,.15)}
.bsc-hero h1{margin:8px 0;font-size:34px}.bsc-hero p{margin:0;max-width:720px;color:#d9eee9;line-height:1.75}.network-chip{font-size:12px;font-weight:800;letter-spacing:.08em;color:#f4d76d}.tron-link{padding:11px 16px;border:1px solid rgba(255,255,255,.35);border-radius:10px;color:white;text-decoration:none}
.workspace{display:grid;grid-template-columns:minmax(330px,460px) minmax(560px,1fr);gap:20px}.create-panel,.payment-panel,.records-panel{border:1px solid #d9e4df;border-radius:16px;background:rgba(255,255,255,.94);box-shadow:0 12px 32px rgba(19,53,45,.07)}
.create-panel{padding:26px}.create-panel header,.payment-header,.payment-footer{display:flex;align-items:center;justify-content:space-between}.create-panel h2{margin:0;font-size:21px}.create-panel header span{color:#718197;font-size:13px}
.asset-switch{display:grid;grid-template-columns:1fr;gap:12px;margin:24px 0}.asset-switch button{display:grid;gap:4px;text-align:left;padding:17px;border:1px solid #d5e0e6;border-radius:12px;background:#f8fafb;color:var(--ink);cursor:pointer}.asset-switch button.selected{border-color:var(--green);background:var(--mint);box-shadow:inset 0 0 0 1px rgba(8,127,103,.1)}.asset-switch button:disabled{cursor:not-allowed;opacity:.58}.asset-switch small{color:#708298}
.order-contract{display:grid;gap:0;border-radius:12px;background:#f3f7f5;padding:2px 14px;margin-bottom:20px}.order-contract div{display:flex;justify-content:space-between;padding:12px 2px;border-bottom:1px solid #dfe9e4}.order-contract div:last-child{border:0}.order-contract span{color:#506b66}
.create-button{width:100%;min-height:46px;border:1px solid #00694f;border-radius:9px;background:linear-gradient(180deg,#0b8b67,#057155);box-shadow:0 4px 0 #035b47,0 10px 22px rgba(5,113,85,.2);color:white;font-weight:800;cursor:pointer}.create-button:disabled{border-color:#c7d0cc;background:#dce2df;box-shadow:0 3px 0 #b4beba;color:#7f8b87;cursor:not-allowed}.privacy-note{font-size:13px;line-height:1.65;color:#64778a;margin:18px 0 0}
.payment-panel{padding:24px;min-height:520px}.payment-panel.active{border-color:#c9dfd6;animation:orderReveal .5s cubic-bezier(.22,1,.36,1)}.payment-header{padding-bottom:18px}.scan-status{display:grid;gap:3px;color:var(--green)}.scan-status.credited{color:#057155}.scan-status>span{font-weight:800}.scan-status small{padding-left:17px;color:#708298;font-weight:500}.status-dot{display:inline-block;width:9px;height:9px;margin-right:8px;border-radius:50%;background:#19b584;box-shadow:0 0 0 7px rgba(25,181,132,.12);animation:statusBreath 2.2s ease-in-out infinite}.deposit-progress{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin:0 0 16px;padding:13px 15px;border:1px solid #a9d9cb;border-radius:12px;background:#effaf6}.deposit-progress>div{display:grid;gap:3px}.deposit-progress small{color:#698078}.deposit-progress strong{color:#0a705c;font-variant-numeric:tabular-nums}.deposit-progress.credited{border-color:#75c7a9;background:#e5f8ef}.countdown{display:flex;align-items:baseline;gap:9px}.countdown strong{font-size:22px;font-variant-numeric:tabular-nums}.countdown.urgent strong{color:#b85b20;animation:countdownFocus 1.1s ease-in-out infinite}
.payment-grid{display:grid;grid-template-columns:300px 1fr;gap:28px;padding:24px;border-radius:15px;background:#f1f6f4}.qr-zone{display:flex;flex-direction:column;align-items:center;gap:10px;padding:18px;border-radius:14px;background:white}.qr-zone small{text-align:center;color:#6b7c8f}.address-zone>span{font-size:13px;color:#708298}.address-row{display:flex;gap:8px;margin:8px 0 18px}.address-row code{flex:1;overflow:hidden;text-overflow:ellipsis;padding:12px;border-radius:8px;background:#e2ebe8}.address-row button,.payment-footer button{border:0;background:none;color:var(--green);font-weight:800;cursor:pointer}.asset-notice{padding:15px;border:1px solid #e8cf83;border-radius:10px;background:#fff9e9}.asset-notice p{margin:6px 0 0;line-height:1.6;color:#715d25}.claim-actions{display:flex;gap:10px;margin-top:10px}.claim-actions button,.claim-actions a{border:1px solid #c9a84d;border-radius:8px;background:#fff;color:#73590f;padding:7px 10px;font-weight:700;text-decoration:none;cursor:pointer}.address-zone ol{padding-left:22px;line-height:2;color:#4c6277}.payment-footer{padding-top:18px;color:#6d7d8e;font-size:13px}.payment-footer button{color:#9a5b1e}
.empty-order{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center}.empty-order h2{margin:22px 0 8px}.empty-order p{max-width:520px;color:#718197;line-height:1.8}.chain-orbit{display:grid;place-items:center;width:92px;height:92px;border-radius:50%;background:var(--mint);box-shadow:0 0 0 16px rgba(231,245,239,.52)}.chain-orbit span{font-weight:900;letter-spacing:.1em;color:var(--green)}
.records-panel{padding:18px 24px}.query-row{display:grid;grid-template-columns:1fr auto auto;gap:10px;align-items:center;padding:10px 0 18px}.query-row a{color:var(--green);font-weight:700;text-decoration:none}.spinner{width:13px;height:13px;border:2px solid rgba(255,255,255,.45);border-top-color:white;border-radius:50%;animation:spin .7s linear infinite}@keyframes spin{to{transform:rotate(360deg)}}@keyframes orderReveal{from{opacity:.4;transform:translateY(12px);filter:blur(4px)}to{opacity:1;transform:none;filter:none}}@keyframes statusBreath{50%{box-shadow:0 0 0 11px rgba(25,181,132,.05);transform:scale(1.12)}}@keyframes countdownFocus{50%{transform:translateY(-1px) scale(1.045);text-shadow:0 7px 18px rgba(184,91,32,.18)}}
@media(prefers-reduced-motion:reduce){.payment-panel.active,.status-dot,.countdown.urgent strong,.spinner{animation:none}}
@media(max-width:1100px){.workspace{grid-template-columns:1fr}.payment-grid{grid-template-columns:1fr}.qr-zone{width:min(100%,320px);justify-self:center}}@media(max-width:700px){.bsc-page{padding:14px}.bsc-hero{align-items:flex-start;gap:20px;padding:22px;flex-direction:column}.asset-switch{grid-template-columns:1fr}.query-row{grid-template-columns:1fr}.payment-panel{padding:14px}.payment-grid{padding:14px}.address-row{flex-direction:column}.deposit-progress{grid-template-columns:1fr}}
</style>
